import React from "react";
import "./Contact.css";

function Contact() {
  const phoneNumber = "8897864796";

  const whatsappMessage =
    "Hello STAR GOLD, I would like to know more about your jewellery collections.";

  const whatsappUrl = `https://wa.me/91${phoneNumber}?text=${encodeURIComponent(
    whatsappMessage,
  )}`;

  const mapUrl =
    "https://www.google.com/maps/search/?api=1&query=STAR+GOLD+COVERING+%26+IMITATION+PRIVATE+LIMITED+Dharmavaram+Andhra+Pradesh";

  return (
    <main className="contact-page">
      <section className="contact-hero">
        <p className="contact-eyebrow">STAR GOLD</p>

        <h1>Get In Touch</h1>

        <p>
          Visit our store or connect with us for jewellery enquiries and
          assistance.
        </p>
      </section>

      <section className="contact-content">
        <div className="contact-card">
          <div className="contact-icon">📍</div>

          <h2>Visit Our Store</h2>

          <p>
            Sub-Jail, RTC Busstand Road,
            <br />
            Akkpedianera, Dharmavaram,
            <br />
            Andhra Pradesh - 515671
          </p>

          <a
            href={mapUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-button"
          >
            View on Google Maps
          </a>
        </div>

        <div className="contact-card">
          <div className="contact-icon">📞</div>

          <h2>Call Us</h2>

          <p>
            Have a question about our collections?
            <br />
            We are happy to help.
          </p>

          <a href={`tel:+91${phoneNumber}`} className="contact-button">
            Call {phoneNumber}
          </a>
        </div>

        <div className="contact-card">
          <div className="contact-icon">💬</div>

          <h2>WhatsApp</h2>

          <p>
            Send us a message on WhatsApp for product enquiries and assistance.
          </p>

          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-button whatsapp-button"
          >
            Chat on WhatsApp
          </a>
        </div>
      </section>

      <section className="contact-bottom">
        <h2>We’d Love To Hear From You</h2>

        <p>Discover elegant jewellery and connect with STAR GOLD today.</p>
      </section>
    </main>
  );
}

export default Contact;
